import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=764e2e0c"
import script from "./DashboardEdit.vue?vue&type=script&lang=js"
export * from "./DashboardEdit.vue?vue&type=script&lang=js"
import style0 from "./DashboardEdit.vue?vue&type=style&index=0&id=764e2e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports